import React from 'react';
import { CalendarIcon, ClockIcon, MonitorIcon, TimerIcon, CheckCircle2Icon } from 'lucide-react';
import { useRegistration } from './RegistrationContext';
import { useWebinarSlot } from './useWebinarSlot';
export const WebinarDetailsCard = () => {
  const {
    openPopup
  } = useRegistration();
  const slot = useWebinarSlot();
  return <section className="mb-12" data-id="element-516" data-mp="1rgzhq1ert4di">
      <div className="bg-blue-50 border border-blue-100 rounded-xl p-8" data-id="element-517" data-mp="26fl4rwr3omaw">
        <div className="flex items-center gap-3 mb-6" data-id="element-518" data-mp="26dgsorj1sgzj">
          <CalendarIcon className="w-6 h-6 text-blue-600" data-id="element-519" data-mp="21h9vpo8mqftq" />
          <h3 className="text-xl font-bold text-gray-900" data-id="element-520" data-mp="21enmzla05u9x">
            Het volgende <span className="text-blue-600" data-id="element-521" data-mp="2f73kk6k4x03g">webinar</span>
          </h3>
        </div>

        <div className="space-y-5 mb-8" data-id="element-522" data-mp="2b7l3jlvfp95w">
          <div className="flex items-center" data-id="element-523" data-mp="2p62l11uqxpfd">
            <CalendarIcon className="w-6 h-6 text-blue-400 mr-4 flex-shrink-0" data-id="element-524" data-mp="2p6uh0ds99p66" />
            <p className="text-lg text-gray-800" data-id="element-525" data-mp="2k7rb6r4gbex5">
              <span className="font-bold" data-id="element-526" data-mp="2k4vdn3wims98">Datum:</span> {slot.dayPrefix}{' '}
              {slot.dateLabel}
            </p>
          </div>
          <div className="flex items-center" data-id="element-527" data-mp="2mmeqsdel5vz4">
            <ClockIcon className="w-6 h-6 text-blue-400 mr-4 flex-shrink-0" data-id="element-528" data-mp="2mn6p3vzki7t3" />
            <p className="text-lg text-gray-800" data-id="element-529" data-mp="2rl870dl9c12z">
              <span className="font-bold" data-id="element-530" data-mp="2vnmp2vh3qwt7">Tijd:</span> {slot.time}
            </p>
          </div>
          <div className="flex items-center" data-id="element-531" data-mp="2vla1o2skru8r">
            <MonitorIcon className="w-6 h-6 text-blue-400 mr-4 flex-shrink-0" data-id="element-532" data-mp="30loavo5wxa8d" />
            <p className="text-lg text-gray-800" data-id="element-533" data-mp="35l9am0swpmm5">
              <span className="font-bold" data-id="element-534" data-mp="35jpqfz44qrf3">Locatie:</span> Online (link wordt na
              registratie verstuurd)
            </p>
          </div>
          <div className="flex items-center" data-id="element-535" data-mp="3fc3tcv6y242u">
            <TimerIcon className="w-6 h-6 text-blue-400 mr-4 flex-shrink-0" data-id="element-536" data-mp="3faspywheuyc9" />
            <p className="text-lg text-gray-800" data-id="element-537" data-mp="3jeibte6pb1tl">
              <span className="font-bold" data-id="element-538" data-mp="3oca6gfyqd21h">Duur:</span> 90 minuten
            </p>
          </div>
          <div className="flex items-center" data-id="element-539" data-mp="1oa0u4lobonfd">
            <CheckCircle2Icon className="w-6 h-6 text-green-500 mr-4 flex-shrink-0" data-id="element-540" data-mp="1oau3zvikvt1q" />
            <p className="text-lg text-gray-800" data-id="element-541" data-mp="1k98l9tjd4kjm">
              <span className="font-bold" data-id="element-542" data-mp="1k6coi8j941wr">Kosten:</span> 100% GRATIS
            </p>
          </div>
        </div>

        <div className="bg-white border border-gray-200 rounded-lg p-5 mb-6" data-id="element-543" data-mp="1t93z664aytnc">
          <p className="font-bold text-gray-900 mb-2 italic" data-id="element-544" data-mp="1t70z0t9frk4w">Belangrijk:</p>
          <p className="text-gray-600 leading-relaxed" data-id="element-545" data-mp="27wp5e8wh58zh">
            Er zijn beperkte plekken beschikbaar per uitzending. Elke maand
            melden zich meer mensen aan, dus reserveer snel je plek!
          </p>
        </div>

        <button onClick={openPopup} className="w-full bg-green-700 hover:bg-green-800 text-white font-bold py-4 px-6 rounded-xl transition-colors text-lg" data-id="element-546" data-mp="2gwlsw774o1sy">
          RESERVEER MIJN PLEK - GRATIS AANMELDEN
        </button>
      </div>
    </section>;
};